module.exports = __webpack_public_path__ + "img/imgtitle.0387a294.png";